import { useCallback, useMemo } from 'react';

export type AssistanceRequirementValues = {
  id: number;
  name: string;
  minPercentage: number;
  activityTypeId: number;
};

type ActivityAttendanceFieldProps = {
  item: AssistanceRequirementValues;
  onChangeItem?: (item: AssistanceRequirementValues) => void;
};

const COLOR: Record<string, string> = {
  '1': '#FFBD71', // Cátedra
  '2': '#ADF7A8', // Ayudantía
  '3': '#ABCCE9', // Laboratorio
  '4': '#EE9EF8', // Terreno
  '5': '#C0BAF5', // Taller
  '6': '#96D192', // Práctica
  '7': '#8EEBE8', // Tesis
  '8': '#FFA19D', // Otro
  '-1': '#CCCCCC', // Online
};

const ActivityAttendanceField = ({
  item,
  onChangeItem,
}: ActivityAttendanceFieldProps) => {
  const formattedValue = useMemo(() => {
    const val = Math.max(
      0,
      Number((item.minPercentage?.toString() || '')?.replace(/\D/g, '') || '0'),
    );

    return val === 0 ? '-' : val.toString();
  }, [item.minPercentage]);

  const validatePercentage = useCallback((value: string) => {
    const MAX_ACCEPTED = 100;
    const numbersOnlyValue = value.replace(/\D/g, '');

    if (isNaN(+numbersOnlyValue)) return value.slice(0, -1);
    if (+numbersOnlyValue > MAX_ACCEPTED) return `${MAX_ACCEPTED}`;

    return numbersOnlyValue;
  }, []);

  const handleChangeValue = useCallback(
    (value: string) => {
      const validatedValue = validatePercentage(value);
      if (onChangeItem) {
        onChangeItem({
          ...item,
          minPercentage: validatedValue === '' ? 0 : +validatedValue,
        });
      }
    },
    [item, onChangeItem, validatePercentage],
  );

  return (
    <div
      className="border border-primary rounded d-flex align-items-center justify-content-center gap-2 overflow-hidden"
      style={{ height: 33, width: 216, background: '#F7F7F7' }}
    >
      <div
        style={{
          backgroundColor: COLOR[String(item.activityTypeId)] || COLOR['8'],
          width: 33,
          height: 33,
        }}
      />
      <span className="flex-fill text-dark fs-16 text-left px-2">{`% ${item.name}`}</span>
      <input
        type="text"
        style={{
          width: 50,
          height: 33,
          transform: 'translateX(1px)',
          background: '#F7F7F7',
          fontSize: 14,
        }}
        id={`percentage-${item.id}`}
        className="border border-primary rounded text-center"
        value={formattedValue}
        onChange={(e) => handleChangeValue(e.target.value)}
      />
    </div>
  );
};

export default ActivityAttendanceField;
